import { createAuthClient } from 'better-auth/react'
import {
  adminClient,
  magicLinkClient,
  organizationClient,
} from 'better-auth/client/plugins'
import {
  ac,
  adminAc,
  admin as adminRole,
  orgAdmin,
  orgMember,
  orgOwner,
  user as userRole,
} from '@shared/permissions'

export const authClient = createAuthClient({
  plugins: [
    magicLinkClient(),
    organizationClient({
      ac,
      roles: {
        owner: orgOwner,
        admin: orgAdmin,
        member: orgMember,
      },
      teams: {
        enabled: false,
      },
    }),
    adminClient({
      ac: adminAc,
      roles: {
        admin: adminRole,
        user: userRole,
      },
    }),
  ],
})
